import { PanelApi } from 'app/shared/ims_panel.service';
import { SiteStateService } from './site_state.service';

/**
 * If the site changes while the given panel is open, close the panel!
 * @param panelApi
 * @param siteStateService
 */
export function onSiteChangeClosePanel(panelApi: PanelApi, siteStateService: SiteStateService) {
    let firstSiteId = siteStateService.selectedSiteId;
    let stillNeedsCleaningUp = siteStateService.onSiteSelectionChanged(async () => {
        // keep listening until we get a valid site id to use as our first site id
        if (!firstSiteId) {
            firstSiteId = siteStateService.selectedSiteId;
            return;
        }

        if (siteStateService.selectedSiteId !== firstSiteId) {
            // site has sufficiently changed; close the panel!
            stillNeedsCleaningUp();
            stillNeedsCleaningUp = null;
            await panelApi.close();
        }
    });

    panelApi.addOnAfterCloseListener(() => {
        // when our panel actually is closed, clean up our listener if it still exists
        if (stillNeedsCleaningUp) {
            stillNeedsCleaningUp();
            stillNeedsCleaningUp = null;
        }
    });
}
